import { createFeatureSelector, createSelector } from '@ngrx/store'
import { PADDLE_NUMBERS_FEATURE_KEY, PaddleNumbersState } from './base-paddle-numbers.reducer'

export const paddleNumbersState = createFeatureSelector<PaddleNumbersState>(PADDLE_NUMBERS_FEATURE_KEY)

export const selectPaddleNumberLoaded = createSelector(
  paddleNumbersState,
  (state: PaddleNumbersState) => state.paddleNumberLoaded,
)
